import { defaultClientConfig } from "clientConfig";
import convert from "color-convert";
const lightenColor = (color, factor) => {
    const result = convert.hex.hsl(color);
    const lightAmount = factor * 100;
    result[2] = Math.min(Math.max(lightAmount + result[2], 0), 100);
    return `#${convert.hsl.hex(result)}`;
};
const setLightDarkCssVariable = (key, value) => {
    const lightenAmount = 5;
    const steps = 100 / lightenAmount;
    for (let i = 1; i <= steps; i++) {
        document.documentElement.style.setProperty(`--${key}_darken_${i * lightenAmount}`, lightenColor(value, -i / steps));
        document.documentElement.style.setProperty(`--${key}_lighten_${i * lightenAmount}`, lightenColor(value, i / steps));
    }
};
const setCssVariable = (key, value) => {
    document.documentElement.style.setProperty(`--${key}`, value);
};
const setCssVariableAndLightDark = (key, value) => {
    setCssVariable(key, value);
    setLightDarkCssVariable(key, value);
};
export function applyStylingTheme(styling) {
    setCssVariableAndLightDark("brandColourPrimary", styling.brandColourPrimary ?? "#2d9fd9");
    setCssVariableAndLightDark("brandColourSecondary", styling.brandColourSecondary ?? "#3d3d3d");
    setCssVariableAndLightDark("brandTextColour", styling.brandTextColour ?? "#3d3d3d");
    setCssVariableAndLightDark("primaryBackground", styling.primaryBackground ?? "#2d9fd9");
    setCssVariableAndLightDark("accentHoverColour", styling.accentHoverColour ?? "#f3f3f3");
    setCssVariableAndLightDark("buttonBackgroundColour", styling.buttonBackgroundColour ?? "#2d9fd9");
    setCssVariableAndLightDark("buttonTextColour", styling.buttonTextColour ?? "#fff");
    setCssVariable("spinnercolour", styling.spinnercolour ?? styling.brandColourPrimary ?? "#2d9fd9");
    setCssVariable("logoMarginBottom", styling.logoMarginBottom ?? "3.2rem");
    setCssVariable("heroPosition", styling.heroPosition ?? "default");
}
export const applyThemeAndConfiguration = (data) => {
    const { styling, configuration } = data;
    applyStylingTheme(styling);
    if (configuration) {
        window.__INTERFI__ = {
            ...defaultClientConfig,
            ...configuration,
        };
    }
};
